import { gql } from "graphql-tag";

export const QUERY_MANUAL_CONTACTS = gql`
  query FetchManualContactsView($id: ID!, $limit: Int!, $offset: Int!, $search: String) {
    interestList(id: $id) {
      id
      name
      scheduledUpdate {
        begins
        ends
        manualContacts(limit: $limit, offset: $offset, search: $search) {
          totalCount
          results {
            name
            phones {
              label
              number
              type
              ext
              enabled
            }
            respondedAt
            status
            interestId
          }
        }
      }
    }
  }
`;

export const MUTATION_SAVE_ACTIVITY = gql`
  mutation SaveManualContactActivity($activity: ActivityInput!) {
    createActivity(data: $activity) {
      id
    }
  }
`;

export const MUTATION_MANUALLY_CONTACTED_WITH_ACTIVITY = gql`
  mutation SaveAsManuallyContactedWithActivity(
    $interest: ID!, 
    $activity: ActivityInput!, 
    $data: FormUpdate!
  ) {
    createActivity(data: $activity) {
      id
    }

    manuallyContacted(
      interestId: $interest, 
      data: $data
    )
  }
`;

export const MUTATION_MANUALLY_CONTACTED_WITHOUT_ACTIVITY = gql`
  mutation SaveAsManuallyContactedWithoutActivity(
    $interest: ID!, 
    $data: FormUpdate!
  ) {

    manuallyContacted(
      interestId: $interest, 
      data: $data
    )
  }
`;

export const MUTATION_REMOVE_FROM_WAITLIST_WITH_ACTIVITY = gql`
  mutation RemoveApplicantFromListWithActivity(
    $interest: ID!, 
    $reason: String!,
    $activity: ActivityInput!
  ) {
    createActivity(data: $activity) {
      id
    }

    changeInterestStatus(interestId: $interest, status: "Removed", reason: $reason)
  }
`;

export const MUTATION_REMOVE_FROM_WAITLIST_WITHOUT_ACTIVITY = gql`
  mutation RemoveApplicantFromList($interest: ID!, $reason: String!) {
    changeInterestStatus(interestId: $interest, status: "Removed", reason: $reason)
  }
`;
